// assets/a24-brand-bar.js
/* Brand carousel controls and responsive centering. */
(function () {
  'use strict';

  function initBrandBar(bar) {
    if (!bar || bar.dataset.brandBarBound === '1') return;

    var carousel = bar.querySelector('.brand-bar__carousel');
    var wrap = bar.querySelector('.brand-bar__slider-wrap');
    var prevBtn = bar.querySelector('.brand-bar__nav--prev');
    var nextBtn = bar.querySelector('.brand-bar__nav--next');
    if (!carousel || !wrap || !prevBtn || !nextBtn) return;

    bar.dataset.brandBarBound = '1';

    function getStep() {
      var attrStep = Number.parseInt(String(bar.getAttribute('data-scroll-step') || ''), 10);
      if (Number.isFinite(attrStep) && attrStep > 0) return attrStep;
      return Math.max(160, Math.round(carousel.clientWidth * 0.8));
    }

    function isCentered() {
      return carousel.classList.contains('is-centered');
    }

    function updateCenteredState() {
      /*
       * The measurement intentionally happens before the centering class is applied.
       * This matches the previously working Preview theme: brands are centered only
       * when their complete row fits without horizontal scrolling.
       */
      carousel.classList.remove('is-centered');
      wrap.classList.remove('is-centered');

      var fitsWithoutScroll = carousel.scrollWidth <= carousel.clientWidth + 1;
      carousel.classList.toggle('is-centered', fitsWithoutScroll);
      wrap.classList.toggle('is-centered', fitsWithoutScroll);

      if (fitsWithoutScroll) {
        carousel.scrollLeft = 0;
      }
    }

    function updateNavState() {
      updateCenteredState();

      var maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
      var left = Math.max(0, carousel.scrollLeft);
      var atStart = isCentered() || left <= 2;
      var atEnd = isCentered() || maxScroll <= 2 || left >= (maxScroll - 2);

      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
      prevBtn.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      nextBtn.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function scheduleUpdate() {
      window.requestAnimationFrame(updateNavState);
    }

    prevBtn.addEventListener('click', function () {
      if (isCentered()) return;
      carousel.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      if (isCentered()) return;
      carousel.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    carousel.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', scheduleUpdate);

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(carousel);
    }

    carousel.querySelectorAll('img').forEach(function (image) {
      if (!image.complete) image.addEventListener('load', scheduleUpdate, { once: true });
    });

    scheduleUpdate();
  }

  function initBrandBars(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var selector = '[data-brand-bar][data-brand-bar-centerable]';

    if (root.matches && root.matches(selector)) {
      initBrandBar(root);
    }

    root.querySelectorAll(selector).forEach(initBrandBar);
  }

  initBrandBars(document);
  document.addEventListener('shopify:section:load', function (event) {
    initBrandBars(event && event.target ? event.target : document);
  });
}());
